import { render, staticRenderFns } from "./asianGamesFull_ASG.vue?vue&type=template&id=63e75046"
import script from "./asianGamesFull_ASG.vue?vue&type=script&lang=js"
export * from "./asianGamesFull_ASG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports